import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { BehaviorSubject, forkJoin, Observable, Subject } from "rxjs";
import { finalize, map, tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class EproductService {
  productIdUpdated = new Subject<number>();
  prodId$: Observable<any> = this.productIdUpdated.asObservable();
  private taxSubject = new BehaviorSubject<any[]>(null);
  tax$: Observable<any[]> = this.taxSubject.asObservable();

  private brandSubject = new BehaviorSubject<any[]>(null);
  brand$: Observable<any[]> = this.brandSubject.asObservable();

  private categorisSubject = new BehaviorSubject<any[]>(null);
  catigories$: Observable<any[]> = this.categorisSubject.asObservable();

  private productTemplateSubject = new BehaviorSubject<any[]>(null);
  productTemp$: Observable<any[]> = this.productTemplateSubject.asObservable();

  private productOptionsSubject = new BehaviorSubject<any[]>(null);
  productOptions$: Observable<any[]> =
    this.productOptionsSubject.asObservable();

  public productId: number = 0;
  public priceType: number = 2;
  constructor(private http: HttpClient, private snotifyService: ToastrService) {
    this.getAll().subscribe();
  }
  ProductName = "";
  ActiveTab = "general";
  brandBody: {
    pageSize: 1000;
    pageNumber: 0;
    searchText: "";
  };

  // ----
  getAll() {
    return forkJoin([
      this.http.get("/tax-classes"),
      // this.http.post<any>('/brands/GetAllBrand',this.brandBody),
      //  N
      //  this.http.get('/categories/GetCategories'),
      this.http.get("/CategoriesApi/GetCategories"),
      // this.http.get('/ProductOptionApis/GetOptions'),
      // this.http.get('/product-templates/GetProductTemplateList'),
    ]).pipe(
      tap((res: any[]) => {
        if (res && res.length > 0) {
          this.taxSubject.next(res[0]);
          //  this.brandSubject.next(res[1])
          this.categorisSubject.next(
            res[1].map((el: any) => (el = { id: el.id, ...el.categoryDetails }))
          );
          console.log(this.catigories$, "CA");

          //  this.productOptionsSubject.next(res[2]),
          //   this.productTemplateSubject.next(res[3])
        }
      })
    );
  }
  public getOptions() {
    return this.http.get(`/ProductOptionApis/GetOptions`);
  }
  public deleteOption(id) {
    return this.http
      .delete(`/ProductOptionApis/DeleteOptions/${id}`)
      .subscribe();
  }
  public AddGeneralProduct(payload: any) {
    return this.http.post<any>(
      `/GeneralProduct/AddGeneralInformation`,
      payload
    );
  }
  getAllCategories() {
    return this.http.get(`/CategoriesApi/GetCategoriesByTypeId/2`);
  }
  public AddProductOptions(payload: any) {
    return this.http.post<any>(`/ProductOptionApis/AddOptions`, payload);
  }

  public GetProductVariation(productId) {
    return this.http.get(`/ProductOptionApis/GetproductVaration/${productId}`);
  }
  public getProductOptions() {
    return this.http.get<any>("/ProductOptionApis/GetOptions");
  }

  public GeneralProductList(payload: any) {
    return this.http.post<any>(`/GeneralProduct/grid`, payload);
  }
  public AddProductFees(payload: any) {
    return this.http.post<any>(
      `/product-additional-fees/AddProductFees`,
      payload
    );
  }

  public GetProductFees(productId) {
    return this.http.get(
      `/product-additional-fees/GetFeesByProductId/${productId}`
    );
  }

  getFeesForProuduct(productId) {
    return this.http.get(
      `/ProductAdditionalFees/GetFeesByProductId/${productId}`
    );
  }

  upsertFeesForProduct(data) {
    return this.http.post("/ProductAdditionalFees/UpsertProductFees", data);
  }
  deleteFeesForProduct(id) {
    return this.http.delete(`/ProductAdditionalFees/DeleteProductFees/${id}`);
  }
  public GetAttributeByTemplateId(templateId) {
    return this.http.get(
      `/ProductAttributeApis/GetAttributeByTemplateId/${templateId}`
    );
  }
  public getAttributeByTemplateId(templateId) {
    return this.http.get(
      `/ProductAttributeApi/GetAttributeByTemplateId/${templateId}`
    );
  }
  public getCategoriesRecursive() {
    let requestOptions = {
      headers: new HttpHeaders({
        cultureId: "3",
      }),
    };
    return this.http.post(
      `/Categories/GetCategoriesNavigator`,
      {
        parentIds: null,
        categoryTypeId: 2,
        activeIds: [],
        orderBy: 1,
        sortType: 1,
        containsFeaturedProduct: null,
        searchValue: "",
      },
      requestOptions
    );
  }
  public GetProductByParentId(id) {
    return this.http.post<any>(`/GeneralProduct/GetProductByParentId/${id}`, {
      params: { id: id },
    });
  }

  getBrandsByCultureId(id) {
    return this.http.get(`/brands/GetBrands/${id}`, {
      params: { CultureId: id },
    });
  }

  getBrandsList() {
    return this.http.get("/brands/GetBrands");
  }

  getAttrebutesByParentId(productId) {
    return this.http.post<any>(
      `/ProductAttributeApis/GetProductAttributeValue/${productId}`,
      { params: { ParentProductId: productId } }
    );
    //.pipe(map((res)=>({id : res.id , name : res.name})));
  }

  // --

  getAttributeValuesByProductId(productId) {
    return this.http.get<any>(
      `/ProductAttributeApi/GetAttributeValuebyProductId/${productId}`
    );
  }

  getProductTemplatsList() {
    return this.http.get("/ProductTemplateApi/GetProductTemplateList");
  }

  //http://localhost:5000/api/ProductLinkApis/GetCrossSellProduct/61

  addProductAttrebutes(productId, payload) {
    return this.http.post<any>(
      "/ProductAttributeApis/AddProductAttributeValue",
      payload
    );
  }
  //AddProductsCategory
  public AddProductsCategor(ProductId, catList) {
    let payload = {
      productId: ProductId,
      categoriesId: catList,
    };
    return this.http.post<any>(
      "/ProductLinkApis/UpsertProductsCategory",
      payload
    );
  }
  getProductTemplate() {
    return this.http.get<any>("/product-templates/GetProductTemplateList");
  }

  public AddCrossSell(ProductId, list) {
    return this.http.post<any>(
      `/ProductLinkApis/UpsertProductLinks/${ProductId}/3`,
      list
    );
  }

  public AddVariation(ProductId, payload) {
    return this.http.post<any>(
      `/ProductOptionApis/AddProductVariations/${ProductId}`,
      payload
    );
  }
  public GetCrossSell(ProductId) {
    return this.http.get<any>(
      `/ProductLinkApis/GetLinkedProducts/${ProductId}/3`
    );
  }

  public AddRelatedProduct(ProductId, list) {
    return this.http.post<any>(
      `/ProductLinkApis/UpsertProductLinks/${ProductId}/2`,
      list
    );
  }
  public GetRelatedProduc(ProductId) {
    return this.http.get<any>(
      `/ProductLinkApis/GetLinkedProducts/${ProductId}/2`
    );
  }
  public AddSubProductsProduct(ProductId, list) {
    return this.http.post<any>(
      `/ProductLinkApis/UpsertProductLinks/${ProductId}/5`,
      list
    );
  }
  public GetSubProducts(ProductId) {
    return this.http.get<any>(
      `/ProductLinkApis/GetLinkedProducts/${ProductId}/5`
    );
  }

  public GetProductsCategories(ProductId) {
    return this.http.get<any>(
      `/ProductLinkApis/getProductsCategory/${ProductId}`,
      { params: { ProductId: ProductId } }
    );
  }

  getAttrebutesGroupes(CultureId) {
    return this.http.get(`/product-attribute-groups/GetAttributeWithGroup`, {
      params: { CultureId: CultureId },
    });
  }
  // /GeneralProduct/DeleteProduct/159

  deleteGeneralProduct(ParentId) {
    return this.http.delete(`/GeneralProduct/DeleteProduct/${ParentId}`, {
      params: { ParentId: ParentId },
    });
  }

  deleteProductVariation(Id) {
    return this.http.post(`/ProductOptionApis/DeleteProductVariation/${Id}`, {
      params: { ProductLinkId: Id },
    });
  }

  /// /GeneralProduct/UpdateProductStatus

  // changeProductStatus(ParentProductId, status) {
  //   return this.http.post(
  //     `/GeneralProduct/UpdateProductStatus/${ParentProductId}/${status}`,
  //     {}
  //   );
  // }

  changeProductStatus(productId, status) {
    return this.http.put(
      `/ProductApi/ChangeStatus/${+productId}/${status}`,
      {}
    );
  }

  // ---A

  getAllProductsList(data) {
    return this.http.post("/ProductApi/GetAllProducts", data);
  }

  addNewProduct(data) {
    return this.http.post("/ProductApi/AddProduct", data);
  }

  getProductById(id) {
    return this.http.post<any>(`/ProductApi/GetProductById/${id}`, { id }).pipe(
      tap((res: any) => {
        this.priceType = res.priceType;
      })
    );
  }
  getAllCountries() {
    return this.http.get<any>(`/countries/GetFilterdCountries`);
  }

  updateProduct(data) {
    return this.http.post("/ProductApi/UpdateProduct", data);
  }

  getAllOptions() {
    /*
0
{id: 3, name: 'Age', siteId: 2}
-
[{
    "id": 17,
    "siteId": 2,
    "optionDetails": [
        {
            "name": "اللون",
            "cultureId": 2,
            "cultureCode": "ar-JO",
            "id": 20
        },
        {
            "name": "Color",
            "cultureId": 3,
            "cultureCode": "en-US",
            "id": 21
        }
    ]
}]

*/

    return this.http.get("/ProductOptionApis/GetOptions").pipe(
      tap((res: any) => {
        console.log(res, "TAP");
        const combinedNamesOptions =
          res && res.length
            ? res.map((element) => {
                let name = "";
                element.optionDetails.forEach((el) => {
                  name += name.length ? ` - ${el.name}` : el.name;
                });
                return (element = { id: element.id, name });
              })
            : null;
        // console.log(combinedNamesOptions,'CO');
        this.productOptionsSubject.next(combinedNamesOptions);
      })
    );
  }

  addOptions(data) {
    return this.http.post("/ProductOptionApis/AddOptions", data);
  }

  addNewVariation(data, productId) {
    return this.http.post(`/Variations/AddProductVariations`, {
      variations: data,
      productId,
    });
  }

  GetAvailableStockByProductId(productID) {
    return this.http.get(
      `/stocks/GetAvailableStockByProductId?ProductId=${productID}`
    );
  }

  upsertProductStock(data: any) {
    return this.http.post("/stocks/UpsertProductStock", data);
  }
  addNewCompination(data, productId) {
    return this.http.post(`/Variations/ModifyVariationCombinations`, {
      variations: data,
      productId,
    });
  }

  getWarehouses() {
    return this.http.get("/warehouses");
  }
  updateVariations(data, productId) {
    return this.http.post(
      `/Variations/EditProductVariations/${productId}`,
      data
    );
  }

  // getVariationsByProductId(productId) {
  //   return this.http.get(`/Variations/GetProductVaration/${productId}`);
  // }
  getVariationsByProductId(productId) {
    return this.http.get(`/Variations/GetProductVarationForAdmin/${productId}`);
  }
  // delete Option .

  // get Variation,

  //

  openNotifySuccess(message: any) {
    this.snotifyService.success(message, "", {
      timeOut: 2500,
      progressBar: true,
      tapToDismiss: true,
    });
  }
  openNotifyError(message: string) {
    this.snotifyService.error(message, "", {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  deleteAllVariations(productId) {
    return this.http.post(`/Variations/DeleteAllVariations/${productId}`, {});
  }
  getProductPriceType() {
    return this.http.get("/ProductApi/GetProductPriceType");
  }
  getProductBranchById(id) {
    return this.http.get(`/ProductBranch/GetProductBranchById/${id}`);
  }
  upsertProductBranch(data) {
    return this.http.post("/ProductBranch/UpsertProductBranch", data);
  }
  addOptionValues(data) {
    return this.http.post("/ProductOptionApis/AddProductsOptionsValue", data);
  }
  editOptionValues(data) {
    return this.http.post(
      "/ProductOptionApis/UpdateProductsOptionsValue",
      data
    );
  }
  orderOptionValues(orderingValues, productId) {
    return this.http.post(
      `/Variations/ChangeOptionOrder/${productId}`,
      orderingValues
    );
  }

  getOrderingOptionValues(productId) {
    return this.http.get(
      `/ProductOptionApis/OptionsDetailsWithOrderingValue/${productId}`
    );
  }

  getOptionsValues(optionId) {
    return this.http.get(
      `/ProductOptionApis/GetProductOptionsValueByOptionId/${optionId}`
    );
  }

  getAllTagsList(TagsValue) {
    return this.http.post("/Tags/GetTagsByEntityType", TagsValue);
  }

  createProductTags(data) {
    return this.http.post("/Tags/CreateTag", data);
  }

  updateProductTags(data) {
    return this.http.post("/Tags/UpdateTag", data);
  }
}
